module.exports = __webpack_public_path__ + "assets/img/18_187.32e230ce.jpg";